import FR from './fr.json';
import GB from './gb.json';
import DE from './de.json';
import AT from './at.json';
import CH from './ch.json';

export const initialVariants = { FR, GB, DE, AT, CH };
